import { Component } from '@angular/core';
import { UnderConstructionComponent } from '../../../core/shared/under-construction/under-construction.component';

@Component({
  selector: 'app-experts-homepage',
  imports: [UnderConstructionComponent],
  templateUrl: './experts-homepage.html',
  styleUrl: './experts-homepage.scss',
})
export class ExpertsHomepage {}
